function FeedbackHeading() {
  return <div className="md-typeset">Is this page helpful?</div>;
}

export default FeedbackHeading;
